module.exports = __webpack_public_path__ + "img/scc-cover.d79260ff.png";